import { Alert, Button, Flex, Typography } from "@papercup-ai/orizuru";
import { UserNotice } from "../utils/userNotice";

/**
 * Banner presentation of a user notice: non-blocking, the page stays usable.
 * Driven by UserNotice, which owns the flag and the acknowledgement.
 *
 * Pinned over the top of the viewport rather than placed in flow: most
 * layouts are sized to 100vh, so an in-flow bar would push them into a
 * scrollbar. It overlaps the page header until acknowledged; the `banner`
 * z-index keeps it above the headers' own pinned elements.
 */
export const UserNoticeBanner = ({
  notice,
  onAcknowledge
}: {
  notice: UserNotice;
  onAcknowledge: () => void;
}) => (
  <Flex position={"fixed"} top={"0"} left={"0"} right={"0"} zIndex={"banner"}>
    {/* The warning tint is a 10% wash, so the page would show through a
        pinned alert. An opaque, theme-aware surface underneath keeps the
        tint and hides the content behind it. */}
    <Flex
      width={"100%"}
      backgroundColor={"tertiaryBackground"}
      boxShadow={"lg"}
    >
      <Alert
        variant={"warning"}
        size={"block"}
        title={notice.title}
        // block alerts pin the trailing element to the top; a one-line bar
        // wants the button centred against the text
        alignItems={"center"}
        borderRadius={"0"}
        endElement={
          <Button variant={"secondary"} size={"sm"} onClick={onAcknowledge}>
            Got it
          </Button>
        }
      >
        {/* pre-line keeps line breaks ops put in the message */}
        <Typography variant={"labelMedium"} whiteSpace={"pre-line"}>
          {notice.message}
        </Typography>
      </Alert>
    </Flex>
  </Flex>
);
